module.exports = __webpack_public_path__ + "7d088296/img/cadBim.e369a02a.png";